import { Section } from "./primitives";

const SENS_COLOR: Record<string, string> = {
  High: "#00E5FF", Elevated: "#A78BFA", Moderate: "#8b93ad",
};

export const Watching = ({ watch }: { watch: any[] }) => {
  if (!watch?.length) return null;
  return (
    <Section num="07" title="What We're Watching" sub="Active themes & their index sensitivity"
      testid="li-watching-section">
      <div className={`grid sm:grid-cols-2 ${watch.length >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"} gap-x-8 gap-y-8`}>
        {watch.map((w) => {
          const color = SENS_COLOR[w.sensitivity] || "#8b93ad";
          return (
            <div key={w.key} className="border-l-2 pl-4" style={{ borderColor: color }}
              data-testid={`li-watch-${w.key}`}>
              <p className="nl-mono text-[10.5px] font-bold uppercase tracking-[0.2em] text-white">{w.title}</p>
              <p className="nl-mono text-[9px] uppercase tracking-[0.16em] mt-1.5" style={{ color }}>
                {w.sensitivity} sensitivity
              </p>
              <p className="text-[12.5px] text-gray-400 leading-relaxed mt-2.5">{w.note}</p>
              <p className="nl-mono text-[9px] text-gray-600 mt-2.5">Affects: {w.component}</p>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-gray-600 mt-6 max-w-2xl leading-relaxed">
        Derived deterministically from the themes currently active in the index — not price predictions.
      </p>
    </Section>
  );
};
